const BASEURL = 'https://reporting.mainsys.eu/admin';

export default BASEURL;
